// extracted by mini-css-extract-plugin
export var areas_title = "style-module--areas_title--HLxfT";
export var areas_list = "style-module--areas_list--1KIHn";
export var radio = "style-module--radio--gcJxB";
export var active = "style-module--active--2FtTy";
export var radio_checked = "style-module--radio_checked--mRGHF";
export var radio_icon = "style-module--radio_icon--34HXa";